export default "__VITE_ASSET__B_jg4IpO__"